import React, {useContext, useEffect, useState} from "react";
import {PageEnum} from "../../../../types/IPage.ts";
import CustomPopup from "../../../../components/CustomPopup";
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import './JoinMatchDialog.css'
import {isEmptyOrNullOrUndefined} from "../../../../common/utils/Datautil.ts";
import {UrlHandler} from "../../../../common/utils/urlHandler/UrlHandler.ts";
import {CommonKey} from "../../../../common/common-key/CommonKey.ts";
import {ToastContext} from "../../../../components/CustomToast/ToastProvider.tsx";
import {apiService} from "../../../../common/utils/http/api-service.ts";
import debounce from "lodash/debounce";
import {IVSPlayerRoomInfo} from "../../../../common/utils/http/IResponse.ts";
import useLoading from "../../../../providers/loadingContext/useLoading.ts";
import {GAEvents} from "../../../../common/utils/GA4/GAEvents.ts";

interface Props {
    isOpen: boolean,
    onClose: () => void,
    switchPage: (page: PageEnum) => void,
    setVsPlayerInfo: (value: IVSPlayerRoomInfo) => void
}

// Join Match弹窗
const JoinMatchDialog: React.FC<Props> = ({isOpen, onClose, setVsPlayerInfo, switchPage}) => {
        // 主题管理器
        const {imgUrls} = useContext(ThemeContext);
        const placeHoldText = "Enter Match Link Here";
        const {addToast} = useContext(ToastContext);
        const {showLoading, hideLoading} = useLoading();


        // 房间id
        const [roomId, setRoomId] = useState<string>('');

        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        function handleChange(event) {
            setRoomId(event.target.value);
        }

        useEffect(() => {
            if (isOpen) {
                // GA埋点
                GAEvents.joinMatchShow()
                const roomUrl = UrlHandler.getCurrentUrlParam(CommonKey.ROOM_ID)
                if (roomUrl) {
                    // 去除roomUrl字符串中问号及问号后面的东西
                    const newRoomUrl = roomUrl.split('?')[0]
                    setRoomId(newRoomUrl)
                    UrlHandler.removeCurrentUrlParam(CommonKey.ROOM_ID)
                }
            } else {
                setRoomId('')
            }
        }, [isOpen]);

        // 调用接口加入房间
        const joinRoomReq = debounce(async (roomId: string) => {
            try {
                showLoading()
                const response = await apiService.joinVsPlayerRoom(roomId);
                if (response.code === 200) {
                    setVsPlayerInfo(response.data)
                    // 成功获取到信息之后进入game界面
                    switchPage(PageEnum.VS_PLAYER_GAME_PAGE)
                } else {
                    addToast({
                        type: 'error',
                        message: response.message,
                    })
                }
            } finally {
                hideLoading()
            }
        }, 100)

        // Join按钮方法
        const handleJoinBtnClick = () => {
            if (isEmptyOrNullOrUndefined(roomId)) {
                return;
            }
            // GA埋点
            GAEvents.joinMatchClick()
            // 如果roomId是以http开头，就提取其中的参数
            if (roomId.startsWith('http')) {
                const roomIdFromUrl = UrlHandler.getUrlParam(roomId, CommonKey.ROOM_ID);
                if (roomIdFromUrl) {
                    joinRoomReq(roomIdFromUrl)
                    return;
                } else {
                    addToast({type: "error", message: "Room ID error."})
                    return;
                }
            } else {
                joinRoomReq(roomId)
            }

        }

        return (
            <CustomPopup isOpen={isOpen} onClose={onClose}>
                <div className="join-match-modal-container">
                    <img className="common-dialog-embellish-bg-left-top" src={imgUrls.leftTopBgDialogUrl} alt="pic"/>
                    <img className="common-dialog-embellish-bg-right-bottom" src={imgUrls.rightBottomBgDialogUrl}
                         alt="pic"/>
                    {/*标题*/}
                    <div
                        className="font-size-16 my-roboto-bold text-center margin-top-11 height-26 display-flex-row display-flex-justify-content-center display-flex-align-items-center">
                        Join Match
                        <img onClick={onClose} src={imgUrls.closerBtnGreyUrl} className="exit-close-btn"
                             alt="pic"/>
                    </div>
                    {/*链接地址框*/}
                    <div className="width-260 height-43 margin-top-27 margin-left-right-auto">
                    <span
                        className="font-size-14 my-roboto-regular margin-left-14 position-absolute height-43 width-40 text-center color-grey display-flex-row display-flex-align-items-center display-flex-justify-content-center">room:</span>
                        <input placeholder={placeHoldText} type={"text"} value={roomId} onChange={handleChange}
                               className={`font-size-14 my-roboto-regular padding-left-60 padding-right-14 text-ellipsis  color-blue width-260 height-43 bg-color-grey-input border-color-grey-input border-radius-5 margin-left-right-auto display-flex-row display-flex-align-items-center`}/>
                    </div>
                    <div onClick={handleJoinBtnClick}
                         className={`${isEmptyOrNullOrUndefined(roomId) ? 'bg-color-grey-btn' : 'bg-btn-blue-color'} font-size-16 my-roboto-medium margin-top-27 width-260 height-43 border-radius-5 color-white margin-left-right-auto display-flex-row display-flex-align-items-center display-flex-justify-content-center`}>Join
                    </div>
                </div>

            </CustomPopup>
        )
    }
;
export default JoinMatchDialog;